<template>
  <div class="notices">
    <base-loading :waitFlg="waitFlg" />
    <p>絞り込み</p>
    <search-area
      :secondFlg="true"
      :radioButtonLabel="'表示'"
      :radioButtonValue="radioButtonValue"
      :radioButtonData="radioButtonData"
      :periodFlg="true"
      :periodLabel="'受信日'"
      :defaultStartDate="defaultStartDate"
      :defaultEndDate="defaultEndDate"
      :searchButtonFlg="true"
      :waitFlg="waitFlg"
      @select-radio-data="changeRadioButtonValue"
      @input-start-date="inputDate($event, 'start')"
      @input-end-date="inputDate($event, 'end')"
      @clear="clearDate"
      @clear-start-date="inputDate('', 'start')"
      @clear-end-date="inputDate('', 'end')"
      @search="resetAndGetData"
    />
    <div class="search-order">
      <div class="order-title">通知一覧</div>
      <div class="data-change-message" v-if="dataChangeFlg">
        ※データの変更が検知されました。検索ボタンを押して更新して下さい。
      </div>
      <div class="order-setting">
        <div class="label">並び替え：</div>
        <base-select-box
          class="select-box"
          :selectData="sortTypes"
          v-model="sortType"
        />
        <base-select-box
          class="select-box"
          :selectData="orderTypes"
          v-model="orderType"
        />
      </div>
    </div>
    <list-table-read
      class="list-table"
      :initialDisplayFlg="initialDisplayFlg"
      :headerData="headers"
      :hitAllDataCounts="hitAllDataCounts"
      :bodyData="bodyData"
      :headerItemStyleData="styles"
      :allReadFlg="true"
      :allReadWaitFlg="waitFlg"
      @click="pushToNoticeShow"
      @read-all="readAll"
      @scroll-bottom="getNextData"
    />
    <announce-popup
      v-if="popupFlg"
      :type="type"
      :title="title"
      :buttons="buttons"
      @close="closePopup"
      >{{ popupMessage }}</announce-popup
    >
  </div>
</template>

<script>
import BaseLoading from '@/components/parts/atoms/BaseLoading'
import SearchArea from '@/components/parts/molecules/SearchArea'
import BaseSelectBox from '@/components/parts/atoms/BaseSelectBox'
import ListTableRead from '@/components/parts/organisms/ListTableRead.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import AnnouncePopup from '@/components/popups/AnnouncePopup'
import { createDisplayBodyData } from '@/utils/list_table_read'

export default {
  name: 'Notices',

  components: {
    BaseLoading,
    SearchArea,
    BaseSelectBox,
    ListTableRead,
    AnnouncePopup
  },

  data() {
    return {
      bodyData: [],
      initialDisplayFlg: true,
      startDate: '',
      defaultStartDate: '',
      endDate: '',
      defaultEndDate: '',
      sortType: 2,
      sortTypes: [
        { id: 2, name: '受信日' },
        { id: 4, name: 'タイトル' },
        { id: 5, name: 'カテゴリ' }
      ],
      orderType: 1,
      orderTypes: [
        { id: 0, name: '昇順' },
        { id: 1, name: '降順' }
      ],
      radioButtonValue: 1,
      radioButtonData: [
        { id: 1, eachValue: 1, labelName: 'すべて' },
        { id: 2, eachValue: 2, labelName: '未読のみ' },
        { id: 3, eachValue: 3, labelName: '既読のみ' }
      ],

      headers: ['', '', '受信日時', 'タイトル', 'カテゴリ'],
      properties: [
        'read',
        'createdAt', //←初期表示時はこの受信日を比較してsortしている
        'receivingDate',
        'title',
        'category'
      ],
      styles: [
        {
          width: '25px',
          color: '#ffa62b',
          fontSize: '8px',
          overflow: 'visible',
          padding: '0'
        },
        { width: '0%', display: 'none' },
        { width: '24%' },
        { width: '50%' },
        { width: '25%' }
      ],
      popupFlg: false,
      type: '',
      title: '',
      popupMessage: '',
      buttons: [],
      waitFlg: false,
      page: 0,
      isFull: true,
      hitAllDataCounts: 0,
      lastUpdated: '',
      dataChangeFlg: false,
      unsubscribe: null,
      markAsReadData: []
    }
  },

  computed: {
    ...mapGetters({
      notices: 'notices/getData',
      getMasterDatum: 'master/getDataById'
    })
  },

  watch: {
    sortType() {
      this.resetAndGetData()
    },
    orderType() {
      this.resetAndGetData()
    },
    markAsReadData() {
      for (const readNotice of this.markAsReadData) {
        const index = this.bodyData.findIndex(v => v.id === readNotice.id)
        if (index !== -1) this.bodyData[index].rowItems[0].itemText = ''
      }
    }
  },

  created() {
    const startMoment = moment().subtract(7, 'd')
    this.startDate = startMoment.format('YYYYMMDD')
    this.defaultStartDate = startMoment.toDate()
    const endMoment = moment()
    this.endDate = endMoment.format('YYYYMMDD')
    this.defaultEndDate = endMoment.toDate()
    this.bodyData = this.createInitialBodyData()
    this.hitAllDataCounts = this.bodyData.length
    this.lastUpdated = moment()
  },

  mounted() {
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (
        mutation.type === 'notices/updateAfter' &&
        mutation.payload.some(notice => {
          const isDeletedDatum =
            notice.delFlg === 1 &&
            moment(notice.updatedAt).isSameOrAfter(this.lastUpdated)
          const isNewDatum = moment(notice.createdAt).isSameOrAfter(
            this.lastUpdated
          )
          if (isDeletedDatum || isNewDatum) {
            // 最終更新日時より後に作られた新規データまたは削除データを判定の対象にする。
            if (
              (this.filterByDate(moment(notice.createdAt).format('YYYYMMDD')) &&
                this.filterByRadioButton(notice)) ||
              this.bodyData.find(v => v.id === notice.id)
            ) {
              //検索条件に一致している、または画面内にデータが表示されている場合、更新を促すメッセージを表示
              return true
            } else {
              return false
            }
          } else {
            false
          }
        })
      ) {
        this.dataChangeFlg = true
      }
      if (mutation.type === 'notices/updateAfter') {
        this.markAsReadData = mutation.payload.filter(
          notice =>
            notice.readFlg === 1 &&
            notice.delFlg === 0 &&
            moment(notice.updatedAt).isSameOrAfter(this.lastUpdated)
        )
      }
    })
  },

  beforeDestroy() {
    this.unsubscribe()
  },

  methods: {
    filterByDate(date) {
      return this.startDate !== '' && this.endDate !== ''
        ? this.startDate <= date && date <= this.endDate
        : this.startDate !== ''
        ? this.startDate <= date
        : this.endDate !== ''
        ? date <= this.endDate
        : true
    },
    filterByRadioButton(notice) {
      return this.radioButtonValue === 1
        ? true
        : this.radioButtonValue === 2
        ? notice.readFlg === 0
        : notice.readFlg === 1
    },
    makeDisplayDatum(notice) {
      return {
        id: notice.id,
        read: notice.readFlg ? '' : '●',
        createdAt: notice.createdAt,
        receivingDate: moment(notice.createdAt).format(
          'YYYY年MM月DD日（dd）HH:mm'
        ),
        rawReceivingDate: notice.createdAt,
        title: notice.title,
        category: this.getMasterDatum(
          'noticeCategories',
          notice.noticeCategoryId
        ).name
      }
    },
    createInitialBodyData() {
      const tmpBodyData = this.notices.flatMap(notice => {
        const formatDate = moment(notice.createdAt).format('YYYYMMDD')
        return this.startDate <= formatDate && formatDate <= this.endDate
          ? { ...this.makeDisplayDatum(notice), number: 0 }
          : []
      })
      return createDisplayBodyData(
        tmpBodyData,
        this.properties,
        this.styles,
        this.initialDisplayFlg,
        this.sortType
      )
    },
    createAddBodyData(resNotices) {
      const lastKey = this.bodyData.length
      const tmpAddBodyData = resNotices.map((notice, index) => {
        return { ...this.makeDisplayDatum(notice), number: lastKey + index }
      })
      return createDisplayBodyData(
        tmpAddBodyData,
        this.properties,
        this.styles,
        this.initialDisplayFlg,
        this.sortType
      )
    },
    async resetAndGetData() {
      this.bodyData = []
      this.page = 0
      this.isFull = false
      this.dataChangeFlg = false
      await this.searchNotices()
    },
    async getNextData() {
      if (!this.isFull && !this.waitFlg) await this.searchNotices()
    },
    async searchNotices() {
      if (this.initialDisplayFlg) this.initialDisplayFlg = false
      this.waitFlg = true
      const res = await this.$store.dispatch('notices/search', {
        startDate: this.startDate,
        endDate: this.endDate,
        page: this.page,
        sortType:
          this.sortType === 2
            ? 'createdAt'
            : this.sortType === 4
            ? 'title'
            : 'category',
        order: this.orderType === 1 ? 'DESC' : 'ASC',
        filter:
          this.radioButtonValue === 1
            ? 'all'
            : this.radioButtonValue === 2
            ? 'unread only'
            : 'read only'
      })
      if (res.result === true) {
        if (this.page === 0) this.hitAllDataCounts = res.hitAllDataCounts
        this.page++
        this.bodyData = this.bodyData.concat(
          this.createAddBodyData(res.notices)
        )
        if (this.bodyData.length < 100 || res.notices.length === 0) {
          this.isFull = true
        }
        if (this.page >= 10 && this.bodyData.length >= 1000) {
          this.isFull = true
          this.popupFlg = true
          this.type = 'alert'
          this.title = '警告'
          this.buttons = ['閉じる']
          this.popupMessage = '通知の表示件数が上限の1000件に達しました。'
        }
        this.lastUpdated = moment()
      } else {
        this.popupFlg = true
        this.type = 'failure'
        this.title = '失敗'
        this.buttons = ['閉じる']
        this.popupMessage = '通信エラーが発生しました。'
      }
      this.waitFlg = false
    },
    changeRadioButtonValue(id) {
      this.radioButtonValue = id
    },
    inputDate(date, dateType) {
      dateType === 'start' ? (this.startDate = date) : (this.endDate = date)
    },
    clearDate() {
      this.startDate = ''
      this.endDate = ''
    },
    async readAll(readIds) {
      this.waitFlg = true
      const result = await this.$store.dispatch('notices/readAll', readIds)
      if (result) {
        this.bodyData = this.bodyData.map(v => {
          if (readIds.includes(v.id)) {
            v.rowItems[0].itemText = ''
            return v
          } else {
            return v
          }
        })
      } else {
        this.popupFlg = true
        this.type = 'alert'
        this.title = 'お知らせ'
        this.buttons = ['閉じる']
        this.popupMessage = 'データが変更された可能性があります。'
      }
      this.waitFlg = false
    },
    closePopup() {
      this.popupFlg = false
      this.type = ''
      this.title = ''
      this.buttons = []
      this.popupMessage = ''
    },
    pushToNoticeShow(id) {
      this.$router.push({ path: `/main/notifications/notices/${id}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.notices {
  > p {
    font-size: 15px;
    font-weight: bold;
  }
  > .search-order {
    margin-top: 15px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    font-size: 13px;
    > .order-title {
      font-size: 15px;
      font-weight: bold;
    }
    > .data-change-message {
      margin-left: 20px;
      margin-top: 3px;
      font-size: 13px;
      font-weight: bold;
      color: #{$tomato};
    }
    > .order-setting {
      display: flex;
      align-items: center;
      margin-left: auto;
      > .select-box {
        margin-left: 10px;
      }
    }
  }
  > .list-table {
    height: calc(100vh - 400px);
    max-height: 664px; // 104px（件数ヘッダー部分の高さ）+ 56px * n（列の高さ×列数）
  }
}
</style>
